import { getBaseTileType } from './tileEntityOptions';

export const TILE_PLACEMENT_CONSTRAINTS = {
  city: {
    entityField: 'commander',
    limit: 1,
    resolution: 'moveExisting',
    label: 'Commander city'
  },
  allianceHall: {
    entityField: 'alliance',
    limit: 1,
    resolution: 'moveExisting',
    label: 'Alliance hall'
  },
  fort: {
    entityField: 'alliance',
    limit: 1,
    resolution: 'moveExisting',
    label: 'Alliance fort'
  },
  institute: {
    entityField: 'alliance',
    limit: 1,
    resolution: 'moveExisting',
    label: 'Alliance institute'
  }
};

const normalizeId = (value) => {
  if (!value) return '';
  if (typeof value === 'object') {
    return String(value._id || value.id || '');
  }
  return String(value);
};

export const getPlacementConstraint = (tileType) => {
  const baseType = getBaseTileType(tileType);
  return TILE_PLACEMENT_CONSTRAINTS[baseType] || null;
};

export const getPlacementConstraintEntityId = (tileType, additionalTileInfo = {}) => {
  const constraint = getPlacementConstraint(tileType);
  if (!constraint) return '';
  return normalizeId(additionalTileInfo?.[constraint.entityField]);
};

export const buildTileConstraintPlacementIndex = (tiles = []) => {
  const index = new Map();
  const seenParents = new Set();

  tiles.forEach((tile) => {
    const parentX = tile.parentTile?.x ?? tile.x;
    const parentY = tile.parentTile?.y ?? tile.y;
    const parentKey = `${parentX},${parentY}`;

    if (seenParents.has(parentKey)) return;
    seenParents.add(parentKey);

    const baseType = getBaseTileType(tile.type);
    const constraint = getPlacementConstraint(baseType);
    if (!constraint) return;

    const entityId = getPlacementConstraintEntityId(baseType, tile.additionalTileInfo || {});
    if (!entityId) return;

    const indexKey = `${baseType}:${entityId}`;
    if (index.has(indexKey)) return;

    index.set(indexKey, {
      tileType: baseType,
      entityId,
      parentKey,
      parentX,
      parentY,
      constraint
    });
  });

  return index;
};

export const findConstraintPlacement = ({
  placementIndex,
  tileType,
  additionalTileInfo,
  entityId
}) => {
  const baseType = getBaseTileType(tileType);
  const resolvedEntityId = entityId || getPlacementConstraintEntityId(baseType, additionalTileInfo);
  if (!resolvedEntityId || !placementIndex) return null;

  return placementIndex.get(`${baseType}:${resolvedEntityId}`) || null;
};
